import Cookies from 'universal-cookie';
import { getDateYearsFromNow } from 'Utils/Date';
import { getDefaultConfig, setState } from 'Utils/Store';

const setPurchaseSourceCookie = (purchaseSource) => {
  const { cookieDomain, purchaseSourceCookieName } = getDefaultConfig();
  const oneYear = getDateYearsFromNow(1);
  const cookieOptions = { path: '/', domain: cookieDomain, expires: oneYear };

  const cookies = new Cookies();
  cookies.set(purchaseSourceCookieName, purchaseSource, cookieOptions);
};

const getQueryStringSource = (window) => {
  const query = new URLSearchParams(window && window.location && window.location.search);
  const source = query.get('source');
  console.debug(`Query string source: ${source}`);
  return source;
};

const getReferrerSource = () => {
  const referrer = document && document.referrer;
  console.debug(`Referrer: ${referrer}`);
  return referrer;
};

export const setSource = (window) => {
  const source = getQueryStringSource(window) || getReferrerSource();
  console.debug(`Adding Source '${source}' to the store...`);

  if (typeof source === 'string' && source.length > 0) {
    return setState('tracking', { source });
  }
};

export const boundSetSource = (window) => setSource(window);
export const trackPageSource = (payload) => setState('tracking', { pageStartSource: payload });
export const trackPageName = (payload) => setState('tracking', { pageName: { ...payload } });
export const trackPurchaseSource = (payload = '') => {
  setPurchaseSourceCookie(payload);
  return setState('tracking', { purchaseSource: payload });
};
